module.exports = __webpack_public_path__ + "static/media/arrow.118a00cf.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/pm/arrow.svg
// module id = 1836
// module chunks = 0